import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { h5, paragraphSmall } from '@helpers/typography';
import styled from 'styled-components';
const Container = styled.section `
  --bgColor: ${brand.beige};
  --fgColor: ${brand.black};

  background-color: var(--bgColor);
  color: var(--fgColor);
  padding: 32px ${fluid(30, 40)} ${fluid(78, 60)};
`;
const TitleWrapper = styled.div `
  display: flex;
  flex-direction: column;
  text-align: center;
`;
const Title = styled.h3 `
  ${h5}
`;
const Subtitle = styled.h4 `
  ${fonts.brandonGrotesque.bold}

  margin-bottom: 2px;
  order: -1;
  text-transform: uppercase;
`;
const DataTable = styled.dl `
  ${paragraphSmall}

  display: grid;
  column-gap: 16px;
  row-gap: 16px;
  grid-template-columns: 1fr auto;
  margin: 0;

  dt {
    text-align: left;
  }

  dd {
    ${fonts.brandonGrotesque.medium}

    text-align: right;
  }
`;
const ExampleTableStyles = {
    Container,
    DataTable,
    Subtitle,
    Title,
    TitleWrapper,
};
export default ExampleTableStyles;
